import { createSelector } from '@ngrx/store'
import { RootState } from '../../root.model'
import { SessionRedux } from './session.reducer'

const sessionsState = (state: RootState) => state.helios.session

export const selectSessions = createSelector(
  sessionsState,
  (state: SessionRedux) => state.sessions,
)

export const selectActiveSession = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession,
)

export const selectActiveSessionIdentifier = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.id,
)

export const selectActiveWindowDate = createSelector(
  sessionsState,
  (state: SessionRedux) =>
    state.activeSession?.auxiliaryInfo?.LOAD_WINDOW_START_DATE,
)

export const selectLoadedForNonDefaultBasis = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.loadedForNonDefaultBasis,
)

export const selectActiveSessionReconDate = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.reconDate,
)

/** First account loaded into the active session, or undefined when none is loaded. */
export const selectFirstLoadedAccountId = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.loadedAccountIds?.[0],
)
export const selectActiveUserId = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.creationUserId,
)

export const selectActualReconDate = createSelector(
  sessionsState,
  (state: SessionRedux) => state.actualReconDate,
)

export const selectIsCreatingSession = createSelector(
  sessionsState,
  (state: SessionRedux) => state.isCreating,
)

export const selectIsSwitchingSession = createSelector(
  sessionsState,
  (state: SessionRedux) => state.isSwitching,
)

export const selectIsHplAccount = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.isHplAccount ?? false,
)

export const selectIsEnfusionAccount = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.isEnfusionAccount ?? false,
)

/**
 * Whether the active session is Enfusion-sourced (`kind === 'ENFN'`), as opposed to a regular
 * Clearwater (`CW`) session. Not to be confused with {@link selectIsEnfusionAccount}, which checks
 * an unrelated, narrowly-scoped ultimate-parent-client flag — this reads the session's actual
 * `kind`, already present on every session payload from the backend.
 */
export const selectIsEnfusionSession = createSelector(
  sessionsState,
  (state: SessionRedux) => state.activeSession?.kind === 'ENFN',
)

export const selectSelectedReconDate = createSelector(
  sessionsState,
  (state: SessionRedux) => state.selectedReconDate,
)
